(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("sourceHireFiltersViewService", SourceHireFiltersViewService);
    SourceHireFiltersViewService.$inject = ['localize'];

    function SourceHireFiltersViewService(localize) {
        var self = this;
        var DROPDOWN_OFFSET = 30;

        self.getAdjustedDropdownPosition = function (dropdownToggleBtn, dropdownMenuElement) {
            var dropdownClientRect = dropdownMenuElement.getBoundingClientRect();
            var dropdownToggleBtnClientRect = dropdownToggleBtn.getBoundingClientRect();
            var viewportWidth = document.documentElement.clientWidth;
            var adjustedFilterClientRect;

            if (localize.isRTL()) {
                var right = viewportWidth - dropdownToggleBtnClientRect.left;
                adjustedFilterClientRect = {
                    left: 'auto',
                    right: 0
                };

                if ((right + dropdownClientRect.width) > viewportWidth) {
                    adjustedFilterClientRect.right = (viewportWidth - (right + dropdownClientRect.width) + DROPDOWN_OFFSET) + 'px';
                }
            } else {
                adjustedFilterClientRect = {
                    right: 'auto',
                    left: 0
                };
                if ((dropdownToggleBtnClientRect.left + dropdownClientRect.width) > viewportWidth) {
                    adjustedFilterClientRect.left = (viewportWidth - (dropdownToggleBtnClientRect.left + dropdownClientRect.width) - DROPDOWN_OFFSET) + 'px';
                }
            }

            return adjustedFilterClientRect;
        };
    }
})();